import { pathOr } from 'ramda'

export const basketSettings = pathOr(
  {
    url: '/gb/api/booking/basket/step1',
    searchQuery: {
      apartment: ['2,0,0,4Md3_MLafx'],
      dateIn: '2018-10-19',
      hotel_id: '6789',
      nbNight: '7',
      q: 'Paris, France',
    },
  },
  ['drupalSettings', 'basket'],
  window,
)

export const hotelCardData = pathOr(
  {
    title: 'Aparthotel Adagio Paris Bercy Village',
    stars: 4,
    hotelLink: 'https://t-ec.bstatic.com/images/hotel/max1280x900/419/41983388.jpg',
    linkToHotel: 'https://www.google.com/',
    brand: 'adagio',
    brandColor: 'red',
    vote: {
      href: 'https://t-ec.bstatic.com/images/hotel/max1280x900/419/41983388.jpg',
      title: 'Voir les 136 avis',
    },
    imgSrc: 'https://t-ec.bstatic.com/images/hotel/max1280x900/419/41983388.jpg',
    imgSrcMobile: 'https://t-ec.bstatic.com/images/hotel/max1280x900/419/41983388.jpg',
    rate: 4.5,
    rateFull: 5,
    location: {
      text: '14 rue du Théâtre 75015 Paris',
      title: 'Voir sur la carte',
      href: 'https://google.com',
    },
    featureImages: [
      {
        className: 'icon-HOUSE_STARS',
        label: 'At the gates of Paris',
      },
      {
        className: 'icon-DOWNTOWN',
        label: 'Near the Bois de Vincennes',
      },
      {
        className: 'icon-E_WLC',
        label: 'Check-in: 3PM - Check-out: 11AM',
      },
    ],
  },
  ['drupalSettings', 'hotel', 'hotelCard'],
  window,
)

export const aparthotelBreadcrumbs = pathOr(
  {
    nameFirstStep: 'Appartement(s) et options',
    linkFirstStep: 'https://www.google.com/',
    nameSecStep: 'Coordonnées et Paiement',
    nameThirdStep: 'Paiement',
  },
  ['drupalSettings', 'aparthotelBreadcrumbs'],
  window,
)

export default pathOr(
  {
    tab: {
      single: '@count person',
      multiple: '@count persons',
      apartment: 'Apartment',
    },
    multipleConfirmation: {
      text: 'Vos trois appartements sont bien sélectionnés, voulez vous :',
      button: 'Confirmez votre réservation',
      link: 'Modifier votre réservation',
    },
    removeUrl: '/',
    priceHelperText: 'Tarif membre',
    priceOldHelperText: 'Tarif public',
  },
  ['drupalSettings', 'rooms'],
  window,
)
